import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequisitosGenerales } from 'src/app/shared/enumeraciones/requisitos-generales.enum';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
import { CapacidadTecnica } from 'src/app/shared/models/requisitos-generales.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from "src/app/shared/models/confirmar-respuesta.model";

import { CampoAdicionalCategoriaService } from '../../campo-adicional-categoria/campo-adicional-categoria.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';

@Component({
  selector: 'app-capacidad-tecnica',
  templateUrl: './capacidad-tecnica.component.html',
  styleUrls: ['./capacidad-tecnica.component.scss']
})
export class CapacidadTecnicaComponent implements OnInit {
  formCapacidadTecnica: FormGroup;
  listCategory: Array<any> = [];
  idEditCapacidadTecnica: number;
  // DataTable
  dataTable: DatoPaginadoModel;
  headertblCapacidadTecnica: Array<string>;
  paginaActual: number;

  created: boolean = true;
  userLogin: any;

  constructor(
    private formBuilder: FormBuilder,
    private campoAdicionalCategoriaService: CampoAdicionalCategoriaService,
    private baseService: BaseServiceService,
    private modalService: NgbModal,
    private authService: AuthService,
  ) { 
    this.paginaActual = 1;
    this.userLogin = authService.getUserNameToken();
  }

  ngOnInit(): void {
    this.getListCapacidadTecnica();
    this.getCategorias();
    this.createForm();

    this.headertblCapacidadTecnica = [
      'categoria',
      'Se muestra comerciante',
      'Obligatorio comerciante',
      'Se muestra no comerciante',
      'Obligatorio no comerciante',
      'Acciones'
    ];
  }

  createForm(){
    this.formCapacidadTecnica = this.formBuilder.group({
      categoria: [null, [Validators.required]],
      obligatorioComerciante: [null, [Validators.required]],
      muestraComerciante: [null],
      obligatorioNoComerciante: [null, [Validators.required]],
      muestraNoComerciante: [null],
    });
  }

  saveSetting(){
    if(this.created){
      let request: CapacidadTecnica = {
        Categoria_Id: this.formCapacidadTecnica.value.categoria,
        Se_Muestra_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.muestraComerciante)),
        Obligatorio_Muestra_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.obligatorioComerciante)),
        Se_Muestra_No_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.muestraNoComerciante)),
        Obligatorio_Muestra_No_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.obligatorioNoComerciante)),
        usuario_auditoria: this.userLogin,
        Tipo_Requisitos_Generales_ID: RequisitosGenerales.CapacidadTecnica
      }

      this.baseService.createCapacidadTecnica(request).subscribe((response) => {
        if(response.result){
          this.getListCapacidadTecnica();
          console.log('OK')
          this.formCapacidadTecnica.reset();
        } else{
          console.log('ERROR')
        }
      });
    } else{
      let request: CapacidadTecnica = {
        Requisitos_Generales_Id: this.idEditCapacidadTecnica,
        Categoria_Id: this.formCapacidadTecnica.value.categoria,
        Se_Muestra_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.muestraComerciante)),
        Obligatorio_Muestra_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.obligatorioComerciante)),
        Se_Muestra_No_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.muestraNoComerciante)),
        Obligatorio_Muestra_No_Comerciante: Boolean(JSON.parse(this.formCapacidadTecnica.value.obligatorioNoComerciante)),
        usuario_auditoria: this.userLogin,
        Tipo_Requisitos_Generales_ID: RequisitosGenerales.CapacidadTecnica
      }

      this.baseService.updateCapacidadTecnica(request).subscribe((response) => {
        if(response){
          this.getListCapacidadTecnica();
          console.log('OK')

          this.formCapacidadTecnica.reset();
        } else{
          console.log('ERROR')
        }
      });
    }
  }

  getCategorias(){
    this.campoAdicionalCategoriaService.getCategoria().subscribe((response => {
      this.listCategory = response.data;
    }));
  }

  getListCapacidadTecnica(){
    let request = {
        Categoria_Id: 0,
        Se_Muestra_Comerciante: null,
        Obligatorio_Muestra_Comerciante: null,
        Se_Muestra_No_Comerciante: null,
        Obligatorio_Muestra_No_Comerciante: null,
        Fecha_Inicio: null,
        Fecha_Fin: null,
        Tipo_Requisitos_Generales_ID: RequisitosGenerales.CapacidadTecnica
    }

    this.baseService.readCapacidadTecnica(request, this.paginaActual).subscribe((response => {
      this.dataTable = response.data as DatoPaginadoModel;
    }));
  }

  editarCapacidadTecnica(item: CapacidadTecnica){
    this.created = false;
    this.idEditCapacidadTecnica = item.Requisitos_Generales_Id;

    this.formCapacidadTecnica.setValue({ 
      categoria: item.Categoria_Id ,
      muestraComerciante: item.Se_Muestra_Comerciante,
      obligatorioComerciante: item.Obligatorio_Muestra_Comerciante,
      muestraNoComerciante: item.Se_Muestra_No_Comerciante,
      obligatorioNoComerciante: item.Obligatorio_Muestra_No_Comerciante,
    });
  }

  deleteCapacidadTecnica(idCapacidadTecnica: number){
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;

    modalRef.result.then(() => {
      this.baseService.deleteCapacidadTecnica(idCapacidadTecnica).subscribe((response) => {
        if(response.result){
          this.getListCapacidadTecnica();
          console.log('OK');
        } else{
          console.log('ERROR');
        }
      });
    });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.getListCapacidadTecnica();
  }
}
